<template>
  <section class="p-1" aria-labelledby="promotion-barcode-title" role="form">
    <h2 id="promotion-barcode-title" class="sr-only">
      {{ $t('field.promotionBarcode') }}
    </h2>
    <div class="d-flex flex-column noPadding">
      <Input
        id="promotionBarcode"
        :label="$t('field.promotionBarcode')"
        type="text"
        :value="value"
        :error="errorMessage"
        :required="true"
        @input="$emit('input', $event)"
        aria-labelledby="promotion-barcode-title"
      />
    </div>
    <Button
      icon-left="barcode"
      @click="onPromotionBarcodeSelected"
      class="btn btn-accordion"
      :aria-label="$t('button.promotionBarcodeAdd')"
      :aria-describedby="errorMessage ? 'promotionBarcode-error' : null"
      :disabled="!!errorMessage"
    >
      <span>{{ $t('button.apply') }}</span>
    </Button>
    <Button
      icon-left="close"
      :secondary="true"
      @click="close"
      class="btn btn-accordion"
      :aria-label="$t('button.close')"
    >
      <span>{{ $t('button.close') }}</span>
    </Button>
  </section>
</template>

<script>
import Button from "@/components/barrier-free-template-components/Button.vue";
import Input from "@/components/barrier-free-template-components/Input.vue";

export default {
  components: {
    Input,
    Button,
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      errorMessage: null,
    };
  },
  methods: {
    onPromotionBarcodeSelected() {
      this.errorMessage = null;
      const barcode = (this.value || '').trim();
      if (barcode) {
        this.$emit('promotion-barcode-input', barcode);
      } else {
        this.errorMessage = this.$t('notification.promotionBarcodeNotValid');
      }
    },
    close() {
      this.$emit('close');
    },
    handlePromotionBarcodeError(error) {
      this.errorMessage = error || this.$t('notification.promotionBarcodeNotValid');
    },
  },
  mounted() {
    this.$root.$on('promotion-barcode-error', this.handlePromotionBarcodeError);
  },
  beforeDestroy() {
    this.$root.$off('promotion-barcode-error', this.handlePromotionBarcodeError);
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';

.btn-accordion {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  width: 100%;
  margin: 5px 0 0;
}
</style>


